import { requestGlobalUserData } from "../../apis";

export const apiGetUserLevel = ({ params }) =>
  requestGlobalUserData("get", `/userlevel`, params, true, false);
